import * as React from 'react'
import { Box, Input, Button, Icon, styled } from '@design/pt-ui'

const ArrowButton = styled(Button)({
  padding: 0,
  minWidth: 0,
})

export interface SelectOption<T> {
  value: T
  label: string
}
interface SelectProps<T> {
  options: SelectOption<T>[]
  disabled?: boolean
  onChange: (param: T) => void
  value: T
}

export default function SelectArrows<T>(props: SelectProps<T>) {
  const prevValue = () => {
    const currentIndex = props.options.findIndex((o) => o.value === props.value)
    props.onChange(
      props.options[
        currentIndex === -1 ? props.options.length - 1 : currentIndex - 1
      ].value,
    )
  }

  const nextValue = () => {
    if (props.disabled) {
      return
    }

    const currentIndex = props.options.findIndex((o) => o.value === props.value)

    props.onChange(
      props.options[currentIndex === -1 ? 0 : currentIndex + 1].value,
    )
  }

  const { options } = props
  const currentIndex = props.options.findIndex((o) => o.value === props.value)

  return (
    <Box sx={{ display: 'flex' }}>
      <Input
        value={currentIndex === -1 ? '' : options[currentIndex].label}
        disabled={props.disabled}
        sx={{
          '&.Mui-disabled': {
            backgroundColor: 'custom.gray.light',
            cursor: 'not-allowed',
          },
        }}
        readOnly={true}
        fullWidth={true}
      />
      <Box sx={{ display: 'flex' }}>
        <ArrowButton
          title="Next option"
          onClick={nextValue}
          disabled={
            props.disabled ||
            options.length === 0 ||
            currentIndex === options.length - 1
          }>
          <Icon>expand_less</Icon>
        </ArrowButton>
        <ArrowButton
          title="Previous option"
          onClick={prevValue}
          disabled={options.length === 0 || currentIndex === 0}>
          <Icon>expand_more</Icon>
        </ArrowButton>
      </Box>
    </Box>
  )
}
